import { reportDetailsActions } from './reportsDetailsReducer';
import { reportDetailsThunkActions } from './thunk';

export const {
  setWeeklyPayrollReportData,
  setLoadingWeeklyPayrollReport,
  clearWeeklyPayrollReportData,
  setWeeklyPayrollCsvData,
  setPayrollData,
  setLoading,
  setPtoBalances,
  setLoadingPtoBalances,
  setPtoBalancesEmployee,
  setLoadingPtoBalancesEmployee,
  setPtoBalancesEmployeeCsv,
  setLoadingPtoBalancesEmployeeCsv,
  setCallbackReportData,
  setLoadingCallbackReport,
  setPtoReportData,
  setLoadingPtoReport,
  clearPtoReportData,
  clearCsvReportData,
  setOvertimeReportData,
  setLoadingOvertimeReport,
  clearOvertimeReportData,
  setPayrollReportData,
  setLoadingPayrollReport,
  clearPayrollReportData,
  setCsvPayrollReport,
  setLoadCsvPayrollReport,
  setCsvOvertimeReport,
  setLoadCsvOvertimeReport,
  clearCsvOvertimeReportData,
  setOvertimeListMasterReportData,
  setToggleLoadingOvertimeListMasterReportData,
  setMunisReportData,
  setIsLoadingMunisReportData,
  setMunisReportCsvData,
  setIsLoadingMunisCsvData,
  setSwapShiftsData,
  setIsLoadingSwapShifts,
  setAdjustHours,
  setIsLoadingAdjustHours,
  clearAdjustHours,
  setAvailabilityDetail,
  setIsLoadingAvailabilityDetail,
  clearAvailabilityDetail,
  setAvailabilitySummary,
  setIsLoadingAvailabilitySummary,
  clearAvailabilitySummary,
  setMiltonReportData,
  setIsLoadingMiltonReportData,
  setCSVMiltonReportData,
  setCSVIsLoadingMiltonReportData,
  setCharltonReportData,
  setLoadingCharltonReport,
  setCSVCharltonReportData,
  setCSVLoadingCharltonReport,
  setWoburnMunisOvertimeReportData,
  setLoadingWoburnMunisOvertimeReport,
  setWoburnMunisOvertimeCSVReportData,
  setLoadingWoburnMunisOvertimeCSVReport,
  setWoburnMunisPtoReportData,
  setLoadingWoburnMunisPtoReport,
  setWoburnMunisPtoCSVReportData,
  setLoadingWoburnMunisPtoCSVReport,
  setWoburnPTOReportData,
  setLoadingWoburnPTOReport,
  setWoburnPtoCSVReportData,
  setLoadingWoburnPtoCSVReport,
  setWoburnReassignmentReportData,
  setLoadingWoburnReassignmentReportData,
  setCSVWoburnReassignmentReport,
  setIsLoadingCSVWoburnReassignmentReport,
  setWoburnOvertimeReportData,
  setLoadingWoburnOvertimeReport,
  setCSVWoburnOvertimeReportData,
  setLoadingCSVWoburnOvertimeReport,
  setWoburnReportData,
  setIsWoburnReportDataLoading,
  setWoburnCSVReportData,
  setLoadingWoburnCSVReport,
  setAvailableReports,
  setIsAvailableReportsLoading,
  setPtoOptionsList,
  setIsLoadingPtoOptionsList,
  setAbsertCodesList,
  setLoadingAbsertCodesList,
} = reportDetailsActions;

export const {
  getWeeklyPayrollReport,
  getWeeklyPayrollReportCsvData,
  getCallbackReport,
  getPtoBalances,
  getPayrollData,
  getPtoReport,
  getEmployeeList,
  getCsvReport,
  getOvertimeReport,
  getPayrollReport,
  getCsvPayrollReport,
  getCsvOvertimeReport,
  getOvertimeListMasterReport,
  getMunisReportData,
  getMunisReportCsvData,
  getSwapShiftsReportData,
  getAdjustHoursReportData,
  getAvailabilityDetailReportData,
  getAvailabilitySummaryReportData,
  getMiltonReportData,
  getCSVMiltonReportData,
  getCharltonReportData,
  getCSVCharltonReportData,
  getWoburnMunisOvertimeReportData,
  getCSVWoburnMunisOvertimeReportData,
  getWoburnMunisPtoReport,
  getWoburnMunisPtoCSVReportCsvData,
  getWoburnPTOReportData,
  getCSVWoburnPTOReportData,
  getWoburnReassignmentReportData,
  getCSVWoburnReassignmentReport,
  getWoburnOvertimeReportData,
  getCSVWoburnOvertimeReportData,
  getWoburnReportData,
  getWoburnCSVReportData,
  getAvailableReports,
  getPtoOptionListData,
  getPtoBalancesEmployee,
  getAbsertCodesList,
  getPtoBalancesEmployeeCsv,
  getPayperiod,
} = reportDetailsThunkActions;
